import { AccountCountryType } from "@towersystems/roam-common/lib/generated-types";
import { OnboardingFormValues } from "./types";
import * as yup from "yup";

export const defaultFormValues: OnboardingFormValues = {
  countryType: AccountCountryType.AUSTRALIA,
  taxNumber: "",
  businessName: "",
  website: "",
  emailAddress: "",
  phoneNumber: "",
};

export const schema = yup.object().shape({
  countryType: yup
    .mixed<AccountCountryType>()
    .oneOf(Object.values(AccountCountryType))
    .required("Country is required"),
  taxNumber: yup.string().optional(),
  businessName: yup.string().optional(),
  website: yup.string().trim().optional(),
  emailAddress: yup.string().email("Must be a valid email").optional(),
  phoneNumber: yup.string().optional(),
});
